<template>
  <div class="product-wrapper">
    <div class="classification">
      <div class="addClassification">
        <el-button icon="el-icon-plus" @click="addCategory()">
          新增分类</el-button
        >
      </div>
      <div class="container">
        <div
          class="containerItem"
          v-for="(item, index) in selectListData"
          :key="item.id"
          :class="activeIndex === index ? 'active' : ''"
        >
          <div
            v-if="!item.showInput"
            class="title"
            @click="activeData(item, index)"
          >
            {{ item.categoryName }}
          </div>
          <i
            v-if="!item.showInput"
            class="el-icon-delete"
            @click="deleteCategory(item)"
          ></i>

          <el-input
            v-if="item.showInput"
            v-model="item.categoryName"
            @blur="categoryData(item)"
          ></el-input>
          <i
            v-if="item.showInput"
            class="el-icon-delete"
            @click="deleteInput(index)"
            style="margin-left: 10px"
          ></i>
        </div>
      </div>
    </div>
    <el-card>
      <div class="forms">
        <el-button class="btnBackgory" @click="addHomeData('dialogForm')"
          >新增产品</el-button
        >

        <el-table
          ref="table"
          v-loading="loading"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            prop="id"
            label="产品编号"
            min-width="80"
            align="center"
          />
          <el-table-column
            prop="productName"
            label="产品名称"
            min-width="140"
            align="center"
          />
          <el-table-column
            prop="productNo"
            label="产品型号"
            min-width="80"
            align="center"
          />
          <el-table-column
            prop="materialNr"
            label="物料编号"
            min-width="80"
            align="center"
          />
          <el-table-column
            prop="productMaterial"
            label="材质"
            min-width="120"
            align="center"
          />
          <el-table-column
            prop="imgUrl"
            label="图片"
            min-width="80"
            align="center"
          >
            <template #default="scope">
              <img
                style="width: 50px; height: 50px"
                :src="`${uploadUrl}+${scope.row.imgUrl}`"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            show-overflow-tooltip
            min-width="260"
            align="center"
          />
          <el-table-column label="操作" min-width="100" align="center">
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <el-popconfirm
                  title="您确认要删除该条数据吗？"
                  @confirm="deleteOnly(scope.row)"
                >
                  <div slot="reference" class="btn">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.page"
            :page-sizes="[20, 40, 60, 80, 100]"
            :page-size="pageData.pageSize"
            layout="total, prev, pager, next,sizes"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="`${title}产品`"
      :visible.sync="dialogVisible"
      width="750px"
      center
      @close="cancelBtn('dialogForm')"
    >
      <div class="forms">
        <el-form
          :model="dialogForm"
          :rules="dialogRules"
          ref="dialogForm"
          label-width="160px"
          class="demo-dialogForm"
          label-position="left"
        >
          <el-form-item label="分类" prop="categoryId">
            <el-select
              v-model="dialogForm.categoryId"
              :disabled="!!dialogForm.id"
              clearable
            >
              <el-option
                v-for="item in selectListData"
                :label="item.categoryName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input
              v-model="dialogForm.productName"
              placeholder="请输入产品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品型号" prop="productNo">
            <el-input
              v-model="dialogForm.productNo"
              placeholder="请输入产品型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品材质" prop="productMaterial">
            <el-input
              v-model="dialogForm.productMaterial"
              placeholder="请输入产品材质"
            ></el-input>
          </el-form-item>
          <el-form-item label="物料编号" prop="materialNr">
            <el-input
              v-model="dialogForm.materialNr"
              placeholder="请输入物料编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="添加图片" prop="imgUrl" ref="imgUpload">
            <!-- 上传 -->
            <el-upload
              class="avatar-uploader"
              :action="`${upload}/file/uploadNew`"
              :show-file-list="false"
              :on-success="uploadSuccess"
              list-type="picture-card"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input type="textarea" v-model="dialogForm.remark"></el-input>
          </el-form-item>
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')"
              >取 消</el-button
            >
            <el-button
              class="dialogBtnBackgory"
              @click="submitForm('dialogForm')"
              >确 定</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "productManage",
  data() {
    return {
      form: {
        pageAreaId: "",
        updatedBy: "",
        updatedTime: ""
      },
      uploadUrl: "",
      upload: "",
      ids: [],
      title: "新增",
      selectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },
      activeIndex: null,
      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        categoryId: "",
        productName: "",
        productNo: "",
        productMaterial: "",
        materialNr: "",
        imgUrl: "",
        remark: ""
      },
      imgUrl: "",
      dialogRules: {
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" }
        ],
        productName: [
          { required: true, message: "请输入产品名称", trigger: "blur" }
        ],
        productNo: [
          { required: true, message: "请输入产品型号", trigger: "blur" }
        ],
        productMaterial: [
          { required: true, message: "请输入产品材质", trigger: "blur" }
        ],
        materialNr: [
          { required: true, message: "请输入物料编号", trigger: "blur" }
        ],
        imgUrl: [{ required: true, message: "请选择图片" }]
      }
    };
  },
  mounted() {
    this.upload = apis.upload;
    this.uploadUrl = apis.uploadUrl;
    this.getSearchList({ ...this.pageData });
    this.categorySelectList();
  },
  methods: {
    activeData(item, index) {
      this.activeIndex = index;
      const json = {
        ...this.pageData,
        categoryId: item.id
      };
      this.getSearchList(json);
    },
    categorySelectList() {
      apis.productGetCategoryList().then(res => {
        if (res.code === 200) {
          this.selectListData = res.data;
        }
      });
    },
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 新增
    addHomeData(formName) {
      this.categorySelectList();
      this.dialogVisible = true;
      this.title = "新增";
      this.dialogForm = {};
      this.imgUrl = "";
      this.$refs[formName]?.resetFields();
    },
    uploadSuccess(res) {
      if (res.code === 200) {
        this.dialogForm.imgUrl = res.data.id;
        this.imgUrl = apis.uploadUrl + res.data.id;
        this.$refs["imgUpload"].clearValidate();
      }
    },

    // 获取 table 数据
    getSearchList(json) {
      this.loading = true;
      apis.productList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        ...this.form
      };
      this.getSearchList(json);
    },
    //新增分类 按钮
    addCategory() {
      this.selectListData.forEach((item, index) => {
        if (!item.categoryName) {
          this.selectListData.splice(index, 1);
        }
      });
      this.selectListData.push({
        categoryName: "",
        showInput: true
      });
    },
    // 失去焦点，添加分类
    categoryData(item) {
      if (item.categoryName) {
        const json = {
          categoryName: item.categoryName
        };
        apis.productAddAndEditCategory(json).then(res => {
          if (res.code === 200) {
            this.categorySelectList();
            this.$message({
              message: "新增分类成功",
              type: "success"
            });
          }
        });
      } else {
        return this.$message({
          message: "请输入分类",
          type: "warning"
        });
      }
    },
    //  删除 分类
    deleteCategory(item) {
      apis.productDeleteCategory(item.id).then(res => {
        if (res.code === 200) {
          this.categorySelectList();
          this.$message({
            message: "删除分类成功",
            type: "success"
          });
        }
      });
    },
    deleteInput(index) {
      this.selectListData.splice(index, 1);
    },
    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const json = {
            ...this.pageData,
            ...this.dialogForm
          };
          apis.productAddAndEditProduct(json).then(res => {
            if (res.code === 200) {
              this.getSearchList({ ...this.pageData });
              const msg = this.dialogForm.id ? "修改" : "新增";
              this.$message({
                message: `${msg}成功`,
                type: "success"
              });
              this.dialogVisible = false;
            }
          });
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 编辑
    edit(row) {
      this.categorySelectList();
      this.imgUrl = apis.uploadUrl + row.file.id;
      this.dialogForm = JSON.parse(
        JSON.stringify({
          id: row.id,
          categoryId: row.categoryId,
          productName: row.productName,
          productMaterial: row.productMaterial,
          materialNr: row.materialNr,
          productNo: row.productNo,
          imgUrl: row.file.id,
          remark: row.remark
        })
      );
      this.dialogVisible = true;
      this.title = "编辑";
    },
    // 删除一条
    deleteOnly(row) {
      apis.productDeleteProduct([row.id]).then(res => {
        if (res.code === 200) {
          this.getSearchList({ ...this.pageData });
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-wrapper {
  display: flex;
  .classification {
    flex: 1;
    width: 356px;
    margin-top: 20px;
    .addClassification {
      width: 356px;
      text-align: center;
      margin-bottom: 37px;
      ::v-deep .el-button--mini {
        color: #4ebf94;
        border-color: #4ebf94;
      }
    }
    .container {
      width: 356px;
      .containerItem {
        height: 84px;
        padding: 0 20px;
        font-size: 29px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.active {
          background-color: #4ebf94;
        }
        .title {
          width: 300px;
        }
      }
    }
  }
}
::v-deep .el-card {
  margin: 20px;
}
// // 1 解决 table 表头和内容 错乱
// ::v-deep .el-table {
//   th.gutter,
//   colgroup.gutter {
//     width: 0px !important; //此处的宽度值，对应你自定义滚动条的宽度即可
//   }
// }
// // 2 关键css代码
// ::v-deep .el-table__header colgroup col[name="gutter"] {
//   display: table-cell !important;
// }
::v-deep .el-upload {
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-upload:hover {
  border-color: #409eff;
}
::v-deep .el-upload--picture-card {
  line-height: 178px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  ::v-deep .el-form {
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 770px;
    }
    .el-textarea__inner {
      width: 770px;
    }
  }
}
</style>
